var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-5",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('tenant.title')))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('tenant.text')))]),_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.isLoggedin,"color":"primary"},on:{"click":_vm.login}},[_vm._v(" "+_vm._s(_vm.$t('tenant.login'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }